const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '聚合全网优质内容源，每日自动更新精选推荐，覆盖多元兴趣领域',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速访问',
    desc: '智能多线路调度与边缘加速，确保首页入口随时秒开无忧',
  },
  {
    icon: 'ri-4k-line',
    title: '高清体验',
    desc: '支持高清内容浏览，自适应不同设备分辨率，流畅不卡顿',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全私密',
    desc: '全站加密传输，严格保护用户隐私，打造安心浏览环境',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，收藏与浏览记录实时同步',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为什么数百万用户选择今日看料作为首选内容入口
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl p-6 text-center transition-all duration-300 hover:bg-primary-50 cursor-default"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-bold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}